export const dataUrlToBase64 = (dataUrl: string): string => {
  const base64Prefix = 'base64,';
  const base64Index = dataUrl.indexOf(base64Prefix);

  if (base64Index === -1) {
    throw new Error('Invalid data URL format');
  }

  return dataUrl.substring(base64Index + base64Prefix.length);
};

export const getFileExtensionFromDataUrl = (dataUrl: string): string => {
  const match = dataUrl.match(/^data:image\/(png|jpeg|jpg|gif|webp);base64,/);
  return match ? match[1] : 'png';
};

export const base64ToDataUrl = (
  base64: string,
  mimeType: string = 'image/png'
): string => {
  return `data:${mimeType};base64,${base64}`;
};
